import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-kimba',
  templateUrl: './kimba.component.html',
  styleUrls: ['./kimba.component.scss']
})
export class KimbaComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;
  

  ngOnInit(): void {
  }

}
